import type { Editor } from "@tiptap/react";

function rgbToHex(rgb: string): string {
    const m = rgb.match(/rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)/i);
    if (!m) return rgb;
    const r = Number(m[1]);
    const g = Number(m[2]);
    const b = Number(m[3]);
    const hex = ((1 << 24) | (r << 16) | (g << 8) | b)
        .toString(16)
        .slice(1)
        .toUpperCase();
    return `#${hex}`;
}

/**
 * Read the *rendered* text color at the given editor range (or the current
 * selection). Uses `getComputedStyle` so it works whether the color came from
 * a textStyle mark, an inline style on a block element, or CSS inheritance.
 * Returns "" if nothing can be resolved.
 */
export function readRenderedColor(
    editor: Editor,
    range: { from: number; to: number } | null
): string {
    if (typeof window === "undefined") return "";
    try {
        const pos = range?.from ?? editor.state.selection.from;
        const { node } = editor.view.domAtPos(pos);
        const el =
            node.nodeType === Node.ELEMENT_NODE
                ? (node as Element)
                : node.parentElement;
        if (!el) return "";
        const c = window.getComputedStyle(el).color;
        if (!c) return "";
        return rgbToHex(c);
    } catch {
        return "";
    }
}
